import type { ReactNode } from 'react'
import React, { createContext, useMemo } from 'react'

import { SuspenseFallback } from '@fourthwall/components'

import type { useCurrentShopQuery as useCurrentShopQueryType } from '../../Dashboard/hooks/useCurrentShopQuery'
import { useCurrentShopQuery } from '../../Dashboard/hooks/useCurrentShopQuery'

type Props = {
  children: ReactNode
}

export type CurrentShop = NonNullable<
  ReturnType<typeof useCurrentShopQueryType>['currentShopQuery']['data']
>

export type CurrentShopContextType = {
  currentShop: NonNullable<CurrentShop>
}

export const CurrentShopContext = createContext<CurrentShopContextType | undefined>(undefined)

export const CurrentShopProvider = ({ children }: Props) => {
  const { currentShopQuery } = useCurrentShopQuery()

  if (!currentShopQuery.data || currentShopQuery.isError) {
    return <SuspenseFallback />
  }

  const value = useMemo(() => ({ currentShop: currentShopQuery.data }), [currentShopQuery.data])

  return <CurrentShopContext.Provider value={value}>{children}</CurrentShopContext.Provider>
}
